import { Container, Button, Jumbotron, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";



import { MdEdit, MdWhatsapp, MdCheck } from "react-icons/md";
import { FaTelegramPlane, FaBolt, FaCut, FaLock, FaHandshake, FaQuestionCircle, FaHistory,FaShoppingBag } from 'react-icons/fa';

import brand from "./img/img01.png"
import sombra from "./img/sombra-celular.png"
import grupos from "./img/celular-grupos.png"
import afiliados from "./img/afiliados.png"
import app from "./img/celular-app.png"
import google from "./img/playstore.webp"
import apple from "./img/apple.jpg"
import "./styles.scss";
import { Helmet } from "react-helmet";

export default function Home() {
  return (
    <>
      <Helmet title="Portal: Sobre" />
      
      <Container className="mb-5">
        <Col xs={12} className="mt-5">
          <Row className="align-items-center row-cols-1 row-cols-md-2">
          <Col className="mt-5 mt-md-0 text-justify">
              <h2 className="mb-3" style={{fontWeight:'bold'}}>Sobre nós</h2>
              <p style={{fontSize:'20px'}}>
              Nascido em 2020 com objetivo de ajudar o consumidor brasileiro a economizar em suas compras, atualmente os Caçadores de Ofertas contam com uma super comunidade com mais de 70.000 membros ativos nos grupos de ofertas no WhatsApp e Telegram.
              </p>

              <p style={{fontSize:'20px'}}>
              Visando oferecer uma experiência ainda mais completa para o consumidor, lançamos o Portal Caçadores, onde trazemos informações sobre as principais informações úteis para seu dia-a-dia, como reviews e análises sobre produtos pra te ajudar na sua escolha!
              </p>
            </Col>
            <Col className="d-flex align-items-center justify-content-center">
            <Image src={brand}
            height={300}
/>  
            </Col>
            
          </Row>
        </Col>
        <Col xs={12} className="mt-5" style={{ backgroundColor: '#f8f9fa' }}>
        <h2 className="mb-3" style={{ fontWeight: 'bold' }}>Grupos de ofertas</h2>
              <p style={{ fontSize: '25px' , fontWeight: '100'}}>Publicamos diariamente as melhores ofertas dos principais varejistas do Brasil.</p>
              
          <Row className="align-items-center row-cols-1 row-cols-md-2">
            <Col className="mt-5 mt-md-0 text-justify">
              
              
              <div style={{ position: 'relative' }}>
                <Image src={sombra} className="img-fluid" alt="Sombra do Celular" />
                <Image src={grupos} className="img-fluid" style={{ position: 'absolute', top: 0, left: 0 }} alt="Grupos de Ofertas" />
              </div>
            </Col>
            <Col className="d-flex flex-column align-items-start justify-content-center">
              <h3 className="mb-3">Participe</h3>
              <a href="https://caçadoresdeofertas.com.br/whatsapp" rel="noopener noreferrer" className="promo-button-link">
                <Button variant="success" className="mb-2 w-100 btn-block" style={{ backgroundColor: '#00b80a', borderColor: '#25D366', borderRadius: '30px', padding: '12px 24px' }}>
                  <MdWhatsapp size="24px" /> Grupos no WhatsApp
                </Button>
              </a>
              <a href="https://t.me/s/cacadoresofertas" rel="noopener noreferrer" className="promo-button-link">
                <Button variant="info" className="w-100 btn-block" style={{ backgroundColor: '#00acec', borderColor: '#0088cc', borderRadius: '30px', padding: '12px 24px' }}>
                  <FaTelegramPlane size="24px" /> Canal no Telegram
                </Button>
              </a>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4">
            <Image src={afiliados} className="img-fluid" alt="Logos dos Varejistas" />
          </Row>
        </Col>
        <Col xs={12} className="mt-5">
          <Row className="align-items-center row-cols-1 row-cols-md-2">
            <Col className="mt-5 mt-md-0 text-justify">
              <h2 className="mb-3" style={{ fontWeight: 'bold' }}>Baixe nosso app</h2>
              <p style={{ fontSize: '20px' }}>
                Acompanhe as melhores ofertas do Brasil na palma da sua mão, e receba notificações em tempo real das melhores promoções!
              </p>

              
              <div style={{ display: 'flex', justifyContent: 'space-around', width: '100%', margin: '20px 0' }}>
                <a href="https://play.google.com/store/apps/details?id=com.intelsust.cacadoresdeofertas&pli=1" target="_blank" rel="noopener noreferrer">
                  <img src={google} alt="Disponível no Google Play" style={{ height: '60px' }} />
                </a>
                <a href="https://apps.apple.com/br/app/ca%C3%A7adores-de-ofertas/id6504419974" target="_blank" rel="noopener noreferrer">
                  <img src={apple} alt="Baixar na App Store" style={{ height: '60px' }} />
                </a>
              </div>
            </Col>
            <Col className="d-flex align-items-center justify-content-center">
              <Image src={app} height={500} alt="App Screen" />
            </Col>
          </Row>
        </Col>
      </Container>
      <Footer />
    </>
  );
}
